/**
 *
 * Asynchronously loads the component for VolunteerListPage
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
